// 分類列表、搜尋列表、編輯作者 - 遊戲、動漫、小說 新聞元件
import { useTranslation } from 'react-i18next';
import Link from 'next/link';
import Image from 'next/image';

import TagComponent from '../layout/TagComponent'; // 標籤
import { DEFAULT_IMG } from '@/common/constant';
import { formatToDisplay } from '@/common/dateUtils';

const ListComponent = ({ info, location = null }) => {
    const { t } = useTranslation();
    const time = info?.displayTime || info?.releasedTime; // 文章時間
    const category1 = info?.category1; // 主要分類
    const category2 = info?.category2; // 中分類
    const slug = info?.slug; // slug

    const category2Title = t(category2?.toUpperCase()); // 主分類title
    const displayTime = formatToDisplay(time); // 顯示時間
    const link = `/${category1}/${slug}`; // 文章連結

    // 點擊大分類
    const onClickCategory = (e) => {
        e.preventDefault();
        // 路徑變更
        window.history.replaceState({}, '', `/${category1}`);
    };

    return (
        <div
            className="flex group rounded-[6px] overflow-hidden relative bg-white
            flex-shrink trans ulg:flex-col ulg:gap-y-[13px]"
        >
            {/* 左側圖片 */}
            <Link
                href={link}
                className="img-box w-[383px] aspect-[383/202] overflow-hidden flex-shrink-0
                 ulb:w-[329px] ulg:!w-full ulg:rounded-[6px] ulg:!rounded-b-[0]"
            >
                <Image
                    className="hover-img"
                    width={383}
                    height={202}
                    src={info?.img || DEFAULT_IMG}
                    alt={info?.alt || 'news'}
                    sizes="300px"
                />
            </Link>

            {/* 右側內容 */}
            <div className="relative flex flex-col justify-center max-w-full gap-y-[30px] text-left flex-grow flex-shrink px-[45px] py-[16px] ulb:px-[22px] ulg:!pt-0 ulg:!px-[12px] ulg:gap-y-[16px]">
                {/* 連結 */}
                <Link href={link} className="absolute z-[0] top-0 left-0 w-full h-full" />

                {/* 標題 */}
                <h2
                    className="text-h5 text-black9 hover-text group-hover:decoration-black9 line-clamp-2 ulg:text-h6 ulg:line-clamp-none
                dark:group-hover:text-[#fff] dark:group-hover:!decoration-[#fff]"
                >
                    {info?.title}
                </h2>

                {/* 標籤列 */}
                {info?.tags && info?.tags?.length ? (
                    <div className="tag-container">
                        {info?.tags?.map((item, i) => (
                            <TagComponent
                                key={`tag-list-${i}`}
                                location="list"
                                tag={item?.tag || item}
                            />
                        ))}
                    </div>
                ) : null}

                {/* 次分類 + 時間顯示 */}
                <p className="relative z-[1] text-btn2 [&>i]:text-black2 [&_a]:text-bou [&_a]:trans [&>i]:not-italic">
                    {/* 大分類 */}
                    <span className="relative z-[1]">
                        {/* 分類列表 */}
                        {location === 'newsList' ? (
                            <a
                                href={`/${category1}`}
                                className="py-[5px] hover:text-vPurple"
                                onClick={onClickCategory}
                            >
                                {t(category1?.toUpperCase())}
                            </a>
                        ) : (
                            // 其他列表
                            <Link href={`/${category1}`} className="py-[5px] hover:text-vPurple">
                                {t(category1?.toUpperCase())}
                            </Link>
                        )}
                    </span>

                    <i>・</i>

                    {/* 中分類 */}
                    <span className="relative z-[1]">
                        <Link
                            href={`/search/${category2Title}`}
                            className="py-[5px] hover:text-vPurple"
                        >
                            {category2Title}
                        </Link>
                    </span>

                    <i>・</i>

                    <Link
                        href={link}
                        className="absolute top-0 left-0 w-full h-[48px] z-[0]"
                        aria-label="新聞"
                    />

                    {/* 文章時間 */}
                    {displayTime && <span className="text-black2">{displayTime}</span>}
                </p>

                <h3 className="absolute bottom-0 opacity-0 z-[-2]">{info?.brief}</h3>
            </div>
        </div>
    );
};

export default ListComponent;
